import React from 'react';
import { shouldShowMerchants } from 'Selectors';
import { DateService } from 'Services';
import useDeploySummary from 'Hooks/query-hooks/deployment/useDeploySummary';
import DeployCount from 'Components/RulesHeader/DeployButton/DeployCount';
import { Loading } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';

import styles from './NewSimulationSuccessModal.css';

interface Props {
    formValues: NewSimulationFormType;
}

const NewSimulationSuccessModal: React.FC<Props> = ({ formValues }) => {
    const { t } = useTranslation();
    const { isFetching, data } = useDeploySummary();

    return (
        <div>
            {t('new simulation success modal message')}
            <div className={styles.simulationSummary}>
                <div>{t('Simulation Summary')}</div>
                {isFetching && <Loading />}
                {!isFetching && (
                    <div>
                        <ul className={styles.bulletPoints}>
                            <li>{t(`simulationSummary.simulationType.${formValues.simulationType}`)}</li>
                            <li>{t(`simulationSummary.sandbox.${formValues.sandbox}`)}</li>
                            {shouldShowMerchants() && <li>{t('All Merchants')}</li>}
                            {formValues.compare && <li>{t('simulationSummary.compare')}</li>}
                            <li>
                                {t('simulationSummary.start', {
                                    date: DateService.getDate(formValues.start?.toString()),
                                    time: DateService.getTime(formValues.start?.toString())
                                })}
                            </li>
                            <li>{t('simulationSummary.duration', { duration: '24 Hours' })}</li>{' '}
                            {/* TODO: Hardcoded for now */}
                        </ul>
                        <div className={styles.modifiedBulletPoints}>
                            {data && <DeployCount prevDeploymentSummary={data} newDeploymentSummary={data} />}
                        </div>

                        <div>{t('You will find your report in Simulations')}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NewSimulationSuccessModal;
